import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import BillingsList from '../pages/BillingsList.vue';
import DateRangePicker from '../components/DateRangePicker.vue';

class ProfileBillingsComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }
  
  init() {
    if (this.container !== '#billings-list-app') {
      console.error('Invalid container ID for ProfileBillingsComponent');
      return;
    }

    this.app = createApp(BillingsList);

    this.app.component('date-range-picker', DateRangePicker);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6
    });

    this.app.mount(this.container);
  }
}

export default ProfileBillingsComponent; 